(function () {
  if (window.cartLightboxInitialized) return;
  window.cartLightboxInitialized = true;

  let overlayEl = null;
  let imgEl = null;

  function ensureLightbox() {
    if (overlayEl) return;

    overlayEl = document.createElement('div');
    overlayEl.className = 'cart-lightbox';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.innerHTML =
      '<button type="button" class="cart-lightbox__close" aria-label="Close">\u00D7</button>' +
      '<img class="cart-lightbox__img" alt="">';
    document.body.appendChild(overlayEl);

    imgEl = overlayEl.querySelector('.cart-lightbox__img');
    const closeBtn = overlayEl.querySelector('.cart-lightbox__close');

    closeBtn.addEventListener('click', close);
    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlayEl.classList.contains('is-open')) close();
    });
  }

  function open(src) {
    ensureLightbox();
    imgEl.src = src;
    overlayEl.setAttribute('aria-hidden', 'false');
    overlayEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!overlayEl) return;
    if (document.activeElement && overlayEl.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    overlayEl.classList.remove('is-open');
    overlayEl.setAttribute('aria-hidden', 'true');
    imgEl.src = '';
    document.body.style.overflow = '';
  }

  // Event delegation — works after cart re-renders via Section Rendering API
  document.addEventListener('click', function (e) {
    const target = e.target.closest('[data-lightbox-src]');
    if (!target) return;
    e.preventDefault();
    const src = target.getAttribute('data-lightbox-src');
    if (src) open(src);
  });
})();
